import { Children, useMemo } from 'react';
import { useToolbarCollectionContext } from '../ToolbarCollectionContext';
import { FilterElement } from './filterElement';
import type { renderPresetToolbarTag } from '@wix/bex-core';

function hasFilter(e: FilterElement | null | undefined, index: number) {
  const filter = e?.props?.filter;
  if (process.env.NODE_ENV !== 'production') {
    if (filter == null) {
      console.warn(
        `filter component must pass \`filter\` prop directly, missing from CollectionToolbarFilters.children[${index}].props`,
      );
    }
  }
  return filter != null;
}

export const useFiltersSyncProps = (
  children:
    | (FilterElement | undefined | boolean)
    | (FilterElement | undefined | boolean)[],
) => {
  const state = useToolbarCollectionContext();
  const allChildren = useMemo(() => {
    const currentChildren = [];

    if (Array.isArray(children)) {
      currentChildren.push(...children);
    } else {
      currentChildren.push(children);
    }

    return currentChildren;
  }, [children, state.tagsCollectionState]);

  const childrenArr = (
    Children.toArray(allChildren) as (FilterElement & {
      type: {
        displayName?: string;
        renderPresetToolbarTag?: typeof renderPresetToolbarTag;
      };
    })[]
  ).filter(hasFilter);

  const tagsFilter = state.tagsCollectionState?.buildTagsFilterWrapper();

  if (
    tagsFilter &&
    !childrenArr.some(
      (child) => child.props.filter.name === tagsFilter.props.filter.name,
    )
  ) {
    childrenArr.push(tagsFilter as FilterElement);
  }

  return childrenArr;
};
